import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'marv-sub-item',
    templateUrl: './sub-item.component.html',
    styleUrls: ['./sub-item.component.scss'],
})
export class MarvSubItemComponent  implements OnInit {

    constructor() { }

    ngOnInit() {}

}
